module.exports = __webpack_public_path__ + "static/media/b4.a955d7f4.png";